import {arrayed} from "mythil/array";

export const UI_ACTIONS = {
    SET_CURRENT_MODEL_ID: 'set_current_model_id',
    SHOW_CONFIRM_NAVIGATION_DIALOG: 'show_confirm_navigation_dialog',
    HIDE_CONFIRM_NAVIGATION_DIALOG: 'hide_confirm_navigation_dialog',
    LOAD_MODEL_PATH: 'load_model_path',
    SET_ACTIVE_APP_BAR_DIALOG: 'set_active_app_bar_dialog',
    SET_SEARCH_TERM: 'set_search_term',
    CLEAR_SEARCH_ERRORS: 'clear_search_errors'
};

export function setCurrentModelId(id) {
    return { type: UI_ACTIONS.SET_CURRENT_MODEL_ID, id };
}

export function showConfirmNavigationDialog(messages) {
    return { type: UI_ACTIONS.SHOW_CONFIRM_NAVIGATION_DIALOG, messages }
}

export function hideConfirmNavigationDialog() {
    return { type: UI_ACTIONS.HIDE_CONFIRM_NAVIGATION_DIALOG }
}

export function loadModelPath(path, changeRootModel = false, resetValues = false) {
    return { type: UI_ACTIONS.LOAD_MODEL_PATH, path, changeRootModel, resetValues};
}

export function setActiveAppBarDialog(dialog) {
    return { type: UI_ACTIONS.SET_ACTIVE_APP_BAR_DIALOG, dialog }
}

export function setSearchTerm(searchTerm) {
    return { type: UI_ACTIONS.SET_SEARCH_TERM, searchTerm }
}

export function clearSearchErrors() {
    return { type: UI_ACTIONS.CLEAR_SEARCH_ERRORS };
}